import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthProvider';
import TopLoader from './components/Loader/TopLoader';
import OfflineBanner from './components/OfflineBanner/OfflineBanner';

import './i18n';

import './App.scss';
import Bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
import {Tooltip} from 'react-tooltip';

// Dropdowns (row actions menus, etc.) live inside scrollable table containers.
// The default Popper "absolute" strategy gets clipped by that scroll container's
// overflow, cutting the menu off — "fixed" positions it relative to the viewport
// instead, escaping the clip.
Bootstrap.Dropdown.Default.popperConfig = (defaultConfig) => ({ ...defaultConfig, strategy: 'fixed' });

function App() {
  return (
    <BrowserRouter>
      <OfflineBanner />
      <TopLoader />

      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
      
      <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
        />

      <Tooltip id="tooltip" style={{ zIndex: 9999 }} />
    </BrowserRouter>
  );
}

export default App;
